export default __webpack_public_path__ + "static/real-estate-389d66f0c504ee4be4a9fb858e400070.jpg";